/* istanbul ignore file */

import type { SVGProps } from 'react';
import { useTheme } from 'styled-components';

type Props = SVGProps<SVGSVGElement> & {
    mode: 'light' | 'dark';
};

export default function EValueOneToFiveIcon({ mode, ...props }: Props) {
    const theme = useTheme();

    return (
        <svg
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="74"
            height="30"
            viewBox="0 0 74 30"
            {...props}
            role="img"
        >
            <g>
                <path
                    fill="#32D8D2"
                    d="M45.282.703c-2.078 0-4.107.64-5.818 1.837a10.377 10.377 0 0 0-3.762 4.86l-4.263 11.336-3.562-9.43C26.36 5.277 21.95 1.4 17.519.736l10.212 27.154h7.416L45.36.735l-.077-.032Z"
                />
                <path
                    fill="#FF4792"
                    d="M26.181 19.658a16.61 16.61 0 0 0-7.906 1.922 7.396 7.396 0 0 1-3.524.89 7.439 7.439 0 0 1-4.033-1.191 7.59 7.59 0 0 1-2.773-3.2l20.631.04a14.578 14.578 0 0 0-.741-8.864 14.41 14.41 0 0 0-3.166-4.714 14.178 14.178 0 0 0-4.722-3.097A14.02 14.02 0 0 0 14.41.45a14.153 14.153 0 0 0-9.684 4.228A14.553 14.553 0 0 0 .56 14.498c-.046 1.92.287 3.83.98 5.617a14.424 14.424 0 0 0 3.053 4.79 14.192 14.192 0 0 0 4.648 3.21 14.024 14.024 0 0 0 13.702-1.51 14.383 14.383 0 0 0 5.19-6.947h-1.95ZM14.755 7.222c1.513 0 2.99.463 4.24 1.329a7.606 7.606 0 0 1 2.762 3.522H7.753a7.606 7.606 0 0 1 2.762-3.522 7.445 7.445 0 0 1 4.24-1.33Z"
                />
                <path
                    fill="#4C4CC5"
                    d="m17.518.736 6.535 17.375 4.527.009c.247-1.073.372-2.172.373-3.273a14.467 14.467 0 0 0-3.32-9.253l-.108-.126c-.048-.057-.098-.112-.146-.168a15.622 15.622 0 0 0-2.962-2.575A14.005 14.005 0 0 0 17.779.78l-.26-.045v.002ZM28.136 19.656h-1.954c-.51 0-1.017.021-1.524.064l1.428 3.796a14.44 14.44 0 0 0 2.05-3.86Z"
                />
            </g>
            <path
                fill={mode === 'dark' ? theme.colors.dark : '#fff'}
                d="M55.568 20.344h-2.574v-8.712l-1.98 2.034-1.458-1.53 3.78-3.798h2.232v12.006Zm6.05-3.384h-4.32v-1.944h4.32v1.944Zm1.418 1.8 1.404-1.728c.829.846 1.945 1.296 3.204 1.296 1.422 0 2.232-.81 2.232-1.8 0-1.098-.791-1.836-2.16-1.836-.99 0-1.8.306-2.52.99l-1.782-.486V8.338h8.245v2.196h-5.743v3.006c.63-.558 1.603-.99 2.7-.99 2.034 0 3.853 1.44 3.853 3.87 0 2.538-1.908 4.14-4.806 4.14-2.088 0-3.6-.684-4.627-1.8Z"
            />
        </svg>
    );
}
